function initializeSwatchLabelHover() {
    const productCards = document.querySelectorAll('product-card');

    productCards.forEach(card => {
        const selectedLabel = card.querySelector('.color-swatch__selected-label');
        const swatchFieldset = card.querySelector('.product-card__info fieldset'); // Adjust selector if needed

        if (selectedLabel && swatchFieldset) {
            let currentSelectedValue = '';
            const initiallyCheckedInput = swatchFieldset.querySelector(':checked+.color-swatch');

            if (initiallyCheckedInput) {
                currentSelectedValue = initiallyCheckedInput.querySelector('.sr-only')?.innerText;
                // Ensure the label is initially set correctly (Liquid might already do this)
                if (selectedLabel.textContent.trim() === '') {
                    selectedLabel.textContent = currentSelectedValue;
                }
            } else {
                // Fallback if nothing is checked initially, read from the label itself if pre-filled
                currentSelectedValue = selectedLabel.textContent.trim();
            }


            // Use event delegation on the fieldset
            swatchFieldset.addEventListener('mouseover', (event) => {
                // Target might be the input or the label/span inside the label
                const input = event.target.closest('.color-swatch')?.querySelector('.sr-only')?.innerText;
                if (input) {
                    selectedLabel.textContent = input;
                }
            });

            swatchFieldset.addEventListener('mouseout', (event) => {
                // Only revert if the mouse truly left the fieldset or went to a non-swatch element
                if (!event.relatedTarget || !event.relatedTarget.closest('.color-swatch')) {
                    selectedLabel.textContent = currentSelectedValue;
                }
            });

            swatchFieldset.addEventListener('click', (event) => {
                if (event.target.classList.contains('color-swatch')) {
                    currentSelectedValue = event.target.querySelector('.sr-only')?.innerText;
                    if(selectedLabel.textContent !== currentSelectedValue){
                        selectedLabel.textContent = currentSelectedValue; // Fix the label on selection
                    }
                }
            });
        }
    });
}

// Run the function when the DOM is ready or potentially on section load for theme editor compatibility
if (typeof Shopify === 'object' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initializeSwatchLabelHover);
}
document.addEventListener('DOMContentLoaded', initializeSwatchLabelHover);

class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    // Called when element is added to DOM
    this.init();
  }

  init() {
    this.container = this;
    this.productId = this.dataset.productId;
    this.sizeButtons = this.querySelectorAll('.size-button');
    this.quickAddButton = this.querySelector('.quick-add-button');
    this.sizeWrapper = this.querySelector('.size-buttons-wrapper');
    
    if(!this.sizeButtons || !this.quickAddButton || !this.sizeWrapper || !this.productId || !this.container){
      return;
    }

    // Remove existing listeners to avoid duplicates
    this.removeEventListeners();
    
    // Show size buttons if product has variants
    if (this.sizeButtons.length > 0) {
      this.sizeWrapper.style.display = 'block';
    } else {
      this.quickAddButton.style.display = 'block';
    }

    // Attach event listeners
    this.attachEventListeners();
  }

  attachEventListeners() {
    // Store bound functions so we can remove them later
    this.boundColorSelectedHandler = (event) => {
      if (event.detail.productId === this.productId) {
        this.handleColorChange(event.detail.color);
      }
    };
    
    // Listen for color changes
    document.addEventListener('colorSelected', this.boundColorSelectedHandler);

    // Listen for size button clicks
    this.sizeButtons.forEach(button => {
      const handler = (event) => {
        this.handleSizeSelection(event.target);
      };
      button._clickHandler = handler;
      button.addEventListener('click', handler);
    });

    // Listen for quick add button click
    this.boundQuickAddHandler = () => {
      this.addToCart();
    };
    this.quickAddButton.addEventListener('click', this.boundQuickAddHandler);
  }

  removeEventListeners() {
    // Remove color change listener
    if (this.boundColorSelectedHandler) {
      document.removeEventListener('colorSelected', this.boundColorSelectedHandler);
    }

    // Remove size button listeners
    if (this.sizeButtons) {
      this.sizeButtons.forEach(button => {
        if (button._clickHandler) {
          button.removeEventListener('click', button._clickHandler);
          delete button._clickHandler;
        }
      });
    }

    // Remove quick add button listener
    if (this.quickAddButton && this.boundQuickAddHandler) {
      this.quickAddButton.removeEventListener('click', this.boundQuickAddHandler);
    }
  }

  disconnectedCallback() {
    // Called when element is removed from DOM
    this.removeEventListeners();
  }

  reinit() {
    // Public method to reinitialize the component
    this.init();
  }

  handleColorChange(color) {
    let hasAvailableSizes = false;

    this.sizeButtons.forEach(button => {
      const buttonColor = button.dataset.color;
      if (color === 'all' || buttonColor === color) {
        button.style.display = '';
        hasAvailableSizes = true;
      } else {
        button.style.display = 'none';
      }
    });

    // Reset selection
    this.sizeButtons.forEach(button => {
      button.setAttribute('aria-pressed', 'false');
    });
    this.quickAddButton.style.display = hasAvailableSizes ? 'block' : 'none';
    this.quickAddButton.disabled = true;
    this.quickAddButton.style.display = 'none';
  }

  handleSizeSelection(selectedButton) {
    // Update aria-pressed state
    this.sizeButtons.forEach(button => {
      button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
    });

    // Update quick add button
    this.quickAddButton.dataset.variantId = selectedButton.dataset.variantId;
    /*
    this.quickAddButton.disabled = false;
    this.quickAddButton.style.display = 'block';
    */
    this.addToCart();
  }

  async addToCart() {
    const variantId = this.quickAddButton.dataset.variantId;
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      if (response.ok) {
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        const cartLink = document.querySelector('.header__cart-link a');
        if(cartLink){
          cartLink.click();
        }
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }
}

customElements.define('quick-add-button', QuickAddButton);

function initializeQuickAddButtons() {
  // The custom element will auto-initialize via constructor/connectedCallback
  // Just make sure they're all initialized if needed
  document.querySelectorAll('quick-add-button.quick-add-container').forEach(container => {
    if (container && typeof container.reinit === 'function') {
      // Only reinit if the element doesn't have listeners attached
      if (!container.quickAddButton) {
        container.reinit();
      }
    }
  });

  // Add color selection observer for all product cards
  const colorSwatches = document.querySelectorAll('.product-card__info input[type="radio"]');
  
  colorSwatches.forEach(swatch => {
    // Remove existing listener if any
    if (swatch._colorChangeHandler) {
      swatch.removeEventListener('change', swatch._colorChangeHandler);
    }
    
    // Add new listener
    swatch._colorChangeHandler = (event) => {
      const productCard = event.target.closest('product-card');
      const productId = productCard.dataset.productId;
      const color = event.target.dataset.color;
      
      document.dispatchEvent(new CustomEvent('colorSelected', {
        detail: { productId, color }
      }));
    };
    
    swatch.addEventListener('change', swatch._colorChangeHandler);
  });

  // Initial color check for all cards
  colorSwatches.forEach(swatch => {
    if (swatch.checked) {
      const productCard = swatch.closest('product-card');
      if (productCard) {
        const productId = productCard.dataset.productId;
        const color = swatch.dataset.color;
        
        document.dispatchEvent(new CustomEvent('colorSelected', {
          detail: { productId, color }
        }));
      }
    }
  });
}

// Initialize quick add buttons when DOM is ready or on section load
if (typeof Shopify === 'object' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initializeQuickAddButtons);
}
document.addEventListener('DOMContentLoaded', initializeQuickAddButtons);


// Swatch Slider functionality
function initializeSwatchSliders() {
  // Initialize sliders
  document.querySelectorAll('.swatch-slider').forEach(slider => {
    const fieldset = slider.querySelector('.swatch-slider__fieldset');
    const prevBtn = slider.querySelector('.swatch-slider__btn--prev');
    const nextBtn = slider.querySelector('.swatch-slider__btn--next');

    if (!fieldset || !prevBtn || !nextBtn) return;

    function checkOverflow() {
      const hasOverflow = slider.scrollWidth > slider.clientWidth;
      slider.classList.toggle('swatch-slider--has-overflow', hasOverflow);
      updateButtonStates();
    }

    function updateButtonStates() {
      const isAtStart = slider.scrollLeft <= 1;
      const isAtEnd = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 1;
      
      prevBtn.classList.toggle('swatch-slider__btn--disabled', isAtStart);
      nextBtn.classList.toggle('swatch-slider__btn--disabled', isAtEnd);
    }

    function scrollToDirection(direction) {
      const scrollAmount = slider.clientWidth * 0.8;
      const targetScroll = direction === 'prev' 
        ? slider.scrollLeft - scrollAmount 
        : slider.scrollLeft + scrollAmount;
      
      slider.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }

    // Event listeners
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!prevBtn.classList.contains('swatch-slider__btn--disabled')) {
        scrollToDirection('prev');
      }
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!nextBtn.classList.contains('swatch-slider__btn--disabled')) {
        scrollToDirection('next');
      }
    });

    slider.addEventListener('scroll', updateButtonStates);

    // Intersection Observer for better performance
    const resizeObserver = new ResizeObserver(() => {
      checkOverflow();
    });
    resizeObserver.observe(slider);

    // Initial check
    setTimeout(checkOverflow, 100);
  });
}

// Initialize swatch sliders when DOM is ready or on section load
if (typeof Shopify === 'object' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initializeSwatchSliders);
}
document.addEventListener('DOMContentLoaded', initializeSwatchSliders);

// Check the .product-card__info .swatch-slider for each product card, if it has only one label.color-swatch inside, hide it using display:none
(function hideSingleSwatchSlider() {
  const swatchSliders = document.querySelectorAll('.product-card__info .swatch-slider');
  swatchSliders.forEach(slider => {
    const labels = slider.querySelectorAll('label.color-swatch');
    if (labels.length === 1) {
      labels[0].style.display = 'none';
    }
  });
})();

function getProductHandleFromUrl(url) {
  if (!url) return '';
  const urlParts = url.split('/products/');
  const handleWithParams = urlParts[urlParts.length - 1] || '';
  return handleWithParams.split('?')[0].split('#')[0].replace(/\/$/, '');
}

function updateProductCardBadges(card, sourceRoot) {
  const figure = card.querySelector('.product-card__figure');
  if (!figure || !sourceRoot) return;

  const oldBadges = figure.querySelector(':scope > badge-list, :scope > .badge-list');
  const newBadges = sourceRoot.querySelector('badge-list, .badge-list');

  if (oldBadges && newBadges) {
    oldBadges.replaceWith(newBadges.cloneNode(true));
  } else if (oldBadges && !newBadges) {
    oldBadges.remove();
  } else if (!oldBadges && newBadges) {
    figure.prepend(newBadges.cloneNode(true));
  }
}

function updateProductCardFromColorGroupTemplate(card, handle, clickedSwatch) {
  const template = card.querySelector(`template[data-color-group-card="${handle}"]`);
  if (!template) return false;

  const content = template.content;
  const newPrice = content.querySelector('price-list, .price-list');
  const oldPrice = card.querySelector('.product-card__info price-list, .product-card__info .price-list');

  if (newPrice && oldPrice) {
    oldPrice.replaceWith(newPrice.cloneNode(true));
  }

  updateProductCardBadges(card, content);

  if (clickedSwatch) {
    card.querySelectorAll('.swatch-slider a.color-swatch').forEach((swatch) => {
      swatch.classList.toggle('is-selected', swatch === clickedSwatch);
    });
  }

  return true;
}

function adaptPriceListForCard(sourcePriceList, cardPriceList) {
  const clone = sourcePriceList.cloneNode(true);
  clone.classList.remove('price-list--product');

  const usesHeading = Boolean(cardPriceList.querySelector('sale-price.h6, .h6'));
  clone.querySelectorAll('sale-price, compare-at-price, unit-price').forEach((el) => {
    el.classList.remove('h4', 'h5');
    if (usesHeading) {
      el.classList.add('h6');
    } else {
      el.classList.remove('h6');
    }
  });

  return clone;
}

function updateProductCardPriceFromHtml(card, htmlDoc) {
  const sourcePrice =
    htmlDoc.querySelector('.product-info .price-list') ||
    htmlDoc.querySelector('.product-sticky-bar .price-list') ||
    htmlDoc.querySelector('.price-list');
  const oldPrice = card.querySelector('.product-card__info price-list, .product-card__info .price-list');

  if (!sourcePrice || !oldPrice) return false;

  oldPrice.replaceWith(adaptPriceListForCard(sourcePrice, oldPrice));
  return true;
}

function updateProductCardPriceFromProductData(card, productData) {
  const priceList = card.querySelector('.product-card__info price-list, .product-card__info .price-list');
  if (!priceList || !productData || !productData.price) return;

  const currency = window.Shopify?.currency?.active || 'USD';
  const locale = document.documentElement.lang || 'en-US';
  const formatMoney = (cents) => new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(cents / 100);

  const price = productData.price;
  const compareAtPrice = productData.compare_at_price;
  const onSale = Boolean(compareAtPrice && compareAtPrice > price);
  const salePrice = priceList.querySelector('sale-price');
  let compareEl = priceList.querySelector('compare-at-price');

  if (salePrice) {
    const srOnly = salePrice.querySelector('.sr-only');
    salePrice.textContent = '';
    if (srOnly) salePrice.appendChild(srOnly);
    salePrice.append(document.createTextNode(formatMoney(price)));
    salePrice.classList.toggle('text-on-sale', onSale);
    salePrice.classList.toggle('text-subdued', !onSale);
  }

  if (onSale) {
    if (!compareEl) {
      compareEl = document.createElement('compare-at-price');
      compareEl.className = 'text-subdued line-through';
      priceList.appendChild(compareEl);
    }

    const srOnly = compareEl.querySelector('.sr-only');
    compareEl.textContent = '';
    if (srOnly) compareEl.appendChild(srOnly);
    compareEl.append(document.createTextNode(formatMoney(compareAtPrice)));
  } else if (compareEl) {
    compareEl.remove();
  }

  const figure = card.querySelector('.product-card__figure');
  const badgeList = figure?.querySelector(':scope > badge-list, :scope > .badge-list');
  const saleBadge = badgeList?.querySelector('on-sale-badge, .badge--on-sale');
  if (!onSale && saleBadge) {
    saleBadge.remove();
    if (badgeList && !badgeList.querySelector('.badge, on-sale-badge, sold-out-badge')) {
      badgeList.remove();
    }
  }
}

// Product Card Color Group Update functionality
function initializeProductCardColorGroup() {
  document.querySelectorAll('product-card').forEach(productCard => {
    const swatchLinks = productCard.querySelectorAll('.swatch-slider a.color-swatch');
    
    if (swatchLinks.length === 0) return;
    
    swatchLinks.forEach(swatchLink => {
      swatchLink.addEventListener('click', async (event) => {
        event.preventDefault();
        const targetUrl = swatchLink.getAttribute('href');
        
        if (!targetUrl) return;

        const handle = getProductHandleFromUrl(targetUrl);
        const updatedFromTemplate = updateProductCardFromColorGroupTemplate(productCard, handle, swatchLink);
        
        // Add loading state
        productCard.classList.add('is-loading');
        
        try {
          // Fetch product data as JSON
          const productResponse = await fetch(`/products/${handle}.js`);
          const productData = await productResponse.json();
          
          // Fetch the product page HTML to get the rendered card
          const htmlResponse = await fetch(targetUrl);
          const html = await htmlResponse.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Find the product card in the fetched page
          // This assumes the product page might have related products or similar
          let newProductCard = doc.querySelector(`product-card[handle="${handle}"]`);
          
          // If not found in related products, we need to construct data from the main product
          if (!newProductCard) {
            // Get the main product info from the page
            const mainProductTitle = doc.querySelector('.product-info__title, h1[class*="product"]');
            const mainProductPrice = doc.querySelector('.price-list');
            const mainProductImage = doc.querySelector('.product-gallery__media img, .product__media img');
            
            if (mainProductTitle || mainProductPrice || mainProductImage) {
              updateProductCardFromData(productCard, {
                handle: handle,
                id: productData.id,
                title: productData.title,
                url: targetUrl,
                featured_image: productData.featured_image,
                price: productData.price,
                compare_at_price: productData.compare_at_price,
                available: productData.available,
                variants: productData.variants,
                images: productData.images
              }, swatchLink, doc, { skipPrice: updatedFromTemplate });
            }
          } else {
            updateProductCard(productCard, newProductCard, { skipPrice: updatedFromTemplate });
          }
          
          // Update URL without page reload (optional, uncomment if desired)
          // if (window.history && window.history.replaceState) {
          //   window.history.replaceState({}, '', targetUrl);
          // }
          
        } catch (error) {
          console.error('Error updating product card:', error);
        } finally {
          // Remove loading state
          productCard.classList.remove('is-loading');
        }
      });
    });
  });
}

function updateProductCardFromData(oldCard, productData, clickedSwatch, htmlDoc, options = {}) {
  // Update product title
  const titleElement = oldCard.querySelector('.product-title');
  if (titleElement) {
    titleElement.textContent = productData.title;
    titleElement.href = productData.url;
  }
  
  // Update product images
  const mediaLink = oldCard.querySelector('.product-card__media');
  if (mediaLink && productData.featured_image) {
    mediaLink.href = productData.url;
    
    // Update main image
    const mainImage = mediaLink.querySelector('.product-card__image--primary');
    if (mainImage) {
      mainImage.src = productData.featured_image;
      mainImage.srcset = `${productData.featured_image}&width=200 200w, ${productData.featured_image}&width=400 400w, ${productData.featured_image}&width=600 600w, ${productData.featured_image}&width=800 800w`;
      mainImage.alt = productData.title;
    }
    
    // Remove or update secondary image
    const secondaryImage = mediaLink.querySelector('.product-card__image--secondary');
    if (secondaryImage && productData.images && productData.images.length > 1) {
      secondaryImage.src = productData.images[1];
      secondaryImage.srcset = `${productData.images[1]}&width=200 200w, ${productData.images[1]}&width=400 400w, ${productData.images[1]}&width=600 600w, ${productData.images[1]}&width=800 800w`;
    } else if (secondaryImage) {
      secondaryImage.remove();
    }
  }
  
  // Update price and sale badge unless they were already swapped from the color-group template
  if (!options.skipPrice) {
    const updatedFromHtml = updateProductCardPriceFromHtml(oldCard, htmlDoc);
    if (!updatedFromHtml) {
      updateProductCardPriceFromProductData(oldCard, productData);
    } else {
      const productInfo = htmlDoc.querySelector('.product-info');
      if (productInfo) {
        updateProductCardBadges(oldCard, productInfo);
      }
    }
  }
  
  // Update product handle and ID
  oldCard.setAttribute('handle', productData.handle);
  oldCard.setAttribute('data-product-id', productData.id);
  
  // Update swatch selection
  const allSwatches = oldCard.querySelectorAll('.swatch-slider a.color-swatch');
  allSwatches.forEach(swatch => {
    if (swatch === clickedSwatch) {
      swatch.classList.add('is-selected');
    } else {
      swatch.classList.remove('is-selected');
    }
  });
  
  // Update quick-add-button with new variants
  updateQuickAddButton(oldCard, productData, htmlDoc);
}

function updateProductCard(oldCard, newCard, options = {}) {
  // Update product title
  const oldTitle = oldCard.querySelector('.product-title');
  const newTitle = newCard.querySelector('.product-title');
  if (oldTitle && newTitle) {
    oldTitle.textContent = newTitle.textContent;
    oldTitle.href = newTitle.href;
  }
  
  // Update product images
  const oldFigure = oldCard.querySelector('.product-card__figure');
  const newFigure = newCard.querySelector('.product-card__figure');
  if (oldFigure && newFigure) {
    // Update only the media link, preserving badges and quick buy
    const oldMedia = oldFigure.querySelector('.product-card__media');
    const newMedia = newFigure.querySelector('.product-card__media');
    if (oldMedia && newMedia) {
      oldMedia.href = newMedia.href;
      oldMedia.innerHTML = newMedia.innerHTML;
    }
    
    // Update quick buy buttons if exists
    const oldQuickBuyButton = oldFigure.querySelector('.product-card__quick-add-button');
    const newQuickBuyButton = newFigure.querySelector('.product-card__quick-add-button');
    if (oldQuickBuyButton && newQuickBuyButton) {
      // Update the button and its parent form if it's a simple add to cart
      const oldForm = oldQuickBuyButton.closest('product-form');
      const newForm = newQuickBuyButton.closest('product-form');
      if (oldForm && newForm) {
        oldForm.outerHTML = newForm.outerHTML;
      } else {
        oldQuickBuyButton.outerHTML = newQuickBuyButton.outerHTML;
      }
    }
    
    // Update quick-buy-modal if exists
    const oldQuickBuyModal = oldCard.querySelector('quick-buy-modal');
    const newQuickBuyModal = newCard.querySelector('quick-buy-modal');
    if (oldQuickBuyModal && newQuickBuyModal) {
      oldQuickBuyModal.outerHTML = newQuickBuyModal.outerHTML;
    } else if (newQuickBuyModal && !oldQuickBuyModal) {
      oldFigure.appendChild(newQuickBuyModal);
    } else if (oldQuickBuyModal && !newQuickBuyModal) {
      oldQuickBuyModal.remove();
    }
  }
  
  if (!options.skipPrice) {
    // Update price
    const oldPrice = oldCard.querySelector('.price-list');
    const newPrice = newCard.querySelector('.price-list');
    if (oldPrice && newPrice) {
      oldPrice.innerHTML = newPrice.innerHTML;
      oldPrice.className = newPrice.className;
    }

    // Update sale / custom badges on the card media
    updateProductCardBadges(oldCard, newCard);
  }
  
  // Update vendor if exists
  const oldVendor = oldCard.querySelector('.vendor');
  const newVendor = newCard.querySelector('.vendor');
  if (oldVendor && newVendor) {
    oldVendor.textContent = newVendor.textContent;
  }
  
  // Update product handle and ID
  const newHandle = newCard.getAttribute('handle');
  const newProductId = newCard.getAttribute('data-product-id');
  if (newHandle) oldCard.setAttribute('handle', newHandle);
  if (newProductId) oldCard.setAttribute('data-product-id', newProductId);
  
  // Update color swatches selection state
  const oldSwatches = oldCard.querySelectorAll('.swatch-slider a.color-swatch');
  const newSwatches = newCard.querySelectorAll('.swatch-slider a.color-swatch');
  
  oldSwatches.forEach((oldSwatch, index) => {
    const newSwatch = newSwatches[index];
    if (newSwatch) {
      if (newSwatch.classList.contains('is-selected')) {
        oldSwatch.classList.add('is-selected');
      } else {
        oldSwatch.classList.remove('is-selected');
      }
    }
  });
  
  // Update quick-add-button element (the custom element with size options)
  const oldQuickAddContainer = oldCard.querySelector('quick-add-button.quick-add-container');
  const newQuickAddContainer = newCard.querySelector('quick-add-button.quick-add-container');
  if (oldQuickAddContainer && newQuickAddContainer) {
    oldQuickAddContainer.outerHTML = newQuickAddContainer.outerHTML;
    // Get the new element and reinitialize it after a small delay
    setTimeout(() => {
      const updatedQuickAddContainer = oldCard.querySelector('quick-add-button.quick-add-container');
      if (updatedQuickAddContainer && typeof updatedQuickAddContainer.reinit === 'function') {
        updatedQuickAddContainer.reinit();
      }
    }, 100);
  } else if (newQuickAddContainer && !oldQuickAddContainer) {
    const cardFigure = oldCard.querySelector('.product-card__figure');
    if (cardFigure) {
      cardFigure.appendChild(newQuickAddContainer);
      // Element will auto-initialize via connectedCallback
    }
  } else if (oldQuickAddContainer && !newQuickAddContainer) {
    oldQuickAddContainer.remove();
  }
}

function updateQuickAddButton(oldCard, productData, htmlDoc) {
  const oldQuickAddContainer = oldCard.querySelector('quick-add-button.quick-add-container');
  
  if (!oldQuickAddContainer) {
    return; // No quick-add-button to update
  }
  
  // Try to find the quick-add-button in the fetched HTML
  let newQuickAddContainer = null;
  
  // Look for it in a product card if one exists
  const newProductCard = htmlDoc.querySelector(`product-card[handle="${productData.handle}"]`);
  if (newProductCard) {
    newQuickAddContainer = newProductCard.querySelector('quick-add-button.quick-add-container');
  }
  
  // If found, replace it
  if (newQuickAddContainer) {
    oldQuickAddContainer.outerHTML = newQuickAddContainer.outerHTML;
    // Get the newly inserted element and reinitialize it after a small delay
    // to ensure DOM is fully updated
    setTimeout(() => {
      const updatedQuickAddContainer = oldCard.querySelector('quick-add-button.quick-add-container');
      if (updatedQuickAddContainer && typeof updatedQuickAddContainer.reinit === 'function') {
        updatedQuickAddContainer.reinit();
      }
    }, 100);
  } else {
    // Build it from scratch using productData
    rebuildQuickAddButton(oldQuickAddContainer, productData);
  }
}

function rebuildQuickAddButton(quickAddContainer, productData) {
  // Update the data-product-id
  quickAddContainer.setAttribute('data-product-id', productData.id);
  
  // Clear and rebuild size buttons
  const sizeButtonsGroup = quickAddContainer.querySelector('.size-buttons-group');
  if (sizeButtonsGroup && productData.variants) {
    sizeButtonsGroup.innerHTML = '';
    
    productData.variants.forEach(variant => {
      if (variant.available) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'size-button';
        button.setAttribute('data-variant-id', variant.id);
        button.setAttribute('data-color', (variant.option1 || '').toLowerCase().replace(/\s+/g, '-'));
        button.setAttribute('aria-pressed', 'false');
        button.textContent = variant.option2 || variant.title;
        sizeButtonsGroup.appendChild(button);
      }
    });
  }
  
  // Update the quick-add-button with first available variant
  const quickAddButton = quickAddContainer.querySelector('.quick-add-button');
  if (quickAddButton && productData.variants && productData.variants.length > 0) {
    const firstAvailable = productData.variants.find(v => v.available) || productData.variants[0];
    quickAddButton.setAttribute('data-product-id', productData.id);
    quickAddButton.setAttribute('data-variant-id', firstAvailable.id);
    quickAddButton.disabled = !firstAvailable.available;
  }
  
  // Re-initialize the component with the new buttons
  if (quickAddContainer && typeof quickAddContainer.reinit === 'function') {
    quickAddContainer.reinit();
  }
}

// Initialize on DOM ready
if (typeof Shopify === 'object' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initializeProductCardColorGroup);
}
document.addEventListener('DOMContentLoaded', initializeProductCardColorGroup);

/**
 * CartGiftWrapHybrid - Handles both product-based and free gift wrap options
 * 
 * When a PRODUCT option is selected: adds the product as a cart line item
 * When a FREE option is selected: sets a cart attribute AND removes any product wrap from cart
 * When cleared: removes product wrap from cart AND clears the cart attribute
 */
class CartGiftWrapHybrid extends HTMLElement {
  constructor() {
    super();
    this.propertyLabel = this.dataset.propertyLabel || 'Gift wrap';
    this.currentVariantId = this.dataset.currentVariantId ? parseInt(this.dataset.currentVariantId) : null;
    this.currentAttribute = this.dataset.currentAttribute || '';
    
    this.addEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    const pill = event.target.closest('.cart-gift-wrap__pill');
    const clearButton = event.target.closest('[data-action="clear"]');
    
    if (clearButton) {
      event.preventDefault();
      await this.clearSelection();
      return;
    }
    
    if (!pill || pill.getAttribute('aria-busy') === 'true') {
      return;
    }
    
    event.preventDefault();
    pill.setAttribute('aria-busy', 'true');
    
    try {
      const type = pill.dataset.giftWrapType;
      
      if (type === 'product') {
        await this.selectProductWrap(pill);
      } else if (type === 'free') {
        await this.selectFreeWrap(pill);
      }
      
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      pill.removeAttribute('aria-busy');
    }
  }

  async selectProductWrap(pill) {
    const variantId = parseInt(pill.dataset.variantId);
    const productTitle = pill.dataset.productTitle;
    
    // First, remove any existing gift wrap product from cart
    await this.removeExistingProductWrap();
    
    // Clear the free wrap cart attribute
    await this.clearFreeWrapAttribute();
    
    // Remove "Gift wrap" property from all cart items (switching from free to product)
    await this.removePropertyFromCartItems();
    
    // Add the new product wrap to cart
    const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_gift_wrap': 'true',
            [this.propertyLabel]: productTitle
          }
        }]
      })
    });
    
    if (!addResponse.ok) {
      console.error('Failed to add gift wrap product');
    }
  }

  async selectFreeWrap(pill) {
    const value = pill.dataset.giftWrapValue;
    
    // First, remove any existing gift wrap product from cart
    await this.removeExistingProductWrap();
    
    // Set the free wrap attribute on the cart
    const updateResponse = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'gift_wrap_option': value
        }
      })
    });
    
    if (!updateResponse.ok) {
      console.error('Failed to set gift wrap attribute');
    }
    
    // Also add this property to existing cart items (except gift wrap products)
    await this.addPropertyToCartItems(value);
  }

  async clearSelection() {
    // Remove product wrap from cart
    await this.removeExistingProductWrap();
    
    // Clear the cart attribute
    await this.clearFreeWrapAttribute();
    
    // Remove property from cart items
    await this.removePropertyFromCartItems();
    
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async removeExistingProductWrap() {
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    const cart = await cartResponse.json();
    
    for (const item of cart.items) {
      if (item.properties && item.properties['_gift_wrap'] === 'true') {
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
      }
    }
  }

  async clearFreeWrapAttribute() {
    // This only clears the cart-level attribute, not item properties
    // Item properties are handled by removePropertyFromCartItems()
    await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'gift_wrap_option': ''
        }
      })
    });
  }

  async addPropertyToCartItems(value) {
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    const cart = await cartResponse.json();
    
    for (const item of cart.items) {
      // Skip gift wrap products themselves
      if (item.properties && item.properties['_gift_wrap'] === 'true') {
        continue;
      }
      
      const currentProperties = item.properties || {};
      
      // Only update if property is different
      if (currentProperties[this.propertyLabel] === value) {
        continue;
      }
      
      const nextProperties = { ...currentProperties };
      nextProperties[this.propertyLabel] = value;
      
      await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: nextProperties
        })
      });
    }
  }

  async removePropertyFromCartItems() {
    // NOTE: According to Shopify's Cart API documentation:
    // "It's not possible to set a line item's properties to an empty object once a value is set."
    // This means if "Gift wrap" is the ONLY property, we cannot remove it via API.
    // We can only remove it if there are other properties to keep.
    
    const propertyKey = this.propertyLabel || 'Gift wrap';
    
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    const cart = await cartResponse.json();
    
    for (const item of cart.items) {
      // Skip gift wrap products
      if (item.properties && item.properties['_gift_wrap'] === 'true') {
        continue;
      }
      
      const currentProperties = item.properties || {};
      
      // Check if the "Gift wrap" property exists
      const hasGiftWrap = currentProperties[propertyKey] !== undefined || 
                         currentProperties['Gift wrap'] !== undefined;
      
      if (!hasGiftWrap) {
        continue;
      }
      
      // Build new properties without gift wrap
      const nextProperties = {};
      let hasOtherProperties = false;
      
      Object.entries(currentProperties).forEach(([key, val]) => {
        // Skip the gift wrap keys
        if (key === propertyKey || key === 'Gift wrap') {
          return;
        }
        if (val !== undefined) {
          nextProperties[key] = val;
          hasOtherProperties = true;
        }
      });
      
      // Only update if there are other properties to keep
      // If Gift wrap is the only property, we add a hidden placeholder to allow "removal"
      if (!hasOtherProperties) {
        // Use a private property (starts with _) that won't show at checkout
        nextProperties['_gift_wrap_cleared'] = 'true';
      }
      
      await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: nextProperties
        })
      });
    }
  }
}

// Register the custom element
if (!window.customElements.get('cart-gift-wrap-hybrid')) {
  window.customElements.define('cart-gift-wrap-hybrid', CartGiftWrapHybrid);
}

/**
 * Gift Wrap Checkout Validation
 * Prevents checkout if gift wrap is enabled and no option is selected
 */
(function() {
  const VALIDATION_CLASS = 'gift-wrap-validation-active';

  function handleFormSubmit(event) {
    const giftWrapComponent = document.querySelector('cart-gift-wrap-hybrid[data-require-selection="true"]');
    if (!giftWrapComponent) return;

    const errorMessage = giftWrapComponent.querySelector('.cart-gift-wrap__error');
    
    const hasProductWrap = giftWrapComponent.dataset.currentVariantId && 
                          giftWrapComponent.dataset.currentVariantId !== '';
    const hasFreeWrap = giftWrapComponent.dataset.currentAttribute && 
                       giftWrapComponent.dataset.currentAttribute !== '';
    const hasSelection = hasProductWrap || hasFreeWrap;

    // Check if checkout button was clicked
    const submitter = event.submitter;
    const isCheckout = submitter && submitter.name === 'checkout';

    if (isCheckout && !hasSelection) {
      event.preventDefault();
      event.stopPropagation();

      // Show error message
      if (errorMessage) {
        errorMessage.style.display = 'block';
        
        // Add wiggle animation
        errorMessage.classList.remove('cart-gift-wrap__error--wiggle');
        void errorMessage.offsetWidth; // Force reflow to restart animation
        errorMessage.classList.add('cart-gift-wrap__error--wiggle');
        
        // Scroll to gift wrap section
        giftWrapComponent.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  function handleGiftWrapClick(event) {
    const pill = event.target.closest('.cart-gift-wrap__pill');
    if (!pill) return;

    const giftWrapComponent = event.currentTarget;
    const errorMessage = giftWrapComponent.querySelector('.cart-gift-wrap__error');
    
    if (errorMessage && errorMessage.style.display !== 'none') {
      errorMessage.style.display = 'none';
    }
  }

  function handleAttributeChange(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes') {
        const giftWrapComponent = mutation.target;
        const errorMessage = giftWrapComponent.querySelector('.cart-gift-wrap__error');
        
        const hasProductWrap = giftWrapComponent.dataset.currentVariantId && 
                              giftWrapComponent.dataset.currentVariantId !== '';
        const hasFreeWrap = giftWrapComponent.dataset.currentAttribute && 
                           giftWrapComponent.dataset.currentAttribute !== '';
        
        if ((hasProductWrap || hasFreeWrap) && errorMessage) {
          errorMessage.style.display = 'none';
        }
      }
    });
  }

  function initGiftWrapCheckoutValidation() {
    const giftWrapComponent = document.querySelector('cart-gift-wrap-hybrid[data-require-selection="true"]');
    if (!giftWrapComponent) return;

    // Check if validation is already active using the class
    if (giftWrapComponent.classList.contains(VALIDATION_CLASS)) return;

    const cartForm = giftWrapComponent.closest('form');
    if (!cartForm) return;

    // Mark as validated
    giftWrapComponent.classList.add(VALIDATION_CLASS);

    // Add form submit listener
    cartForm.addEventListener('submit', handleFormSubmit);

    // Add click listener to gift wrap component
    giftWrapComponent.addEventListener('click', handleGiftWrapClick);

    // Observe changes to data attributes to hide error when selection changes
    const attributeObserver = new MutationObserver(handleAttributeChange);
    attributeObserver.observe(giftWrapComponent, {
      attributes: true,
      attributeFilter: ['data-current-variant-id', 'data-current-attribute']
    });

    // Store observer reference on the element for potential cleanup
    giftWrapComponent._giftWrapObserver = attributeObserver;
  }

  // Check for gift wrap component every 250ms
  setInterval(function() {
    initGiftWrapCheckoutValidation();
  }, 250);

  // Also try to initialize immediately on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftWrapCheckoutValidation);
  } else {
    initGiftWrapCheckoutValidation();
  }
})();

